// extracted by mini-css-extract-plugin
export default {"icon__wrap":"IconWrap_icon__wrap__F7-e5"};